import { Customer, defaultCustomer } from 'shared/types/customer';
import { QuoteLine } from 'shared/types/quoteline';

export interface Quote {
  id?: string;
  customer: Customer;
  quoteLines: QuoteLine[];
  createdBy: string;
  createDate: string;
  expirationDate: string;
  customer_number: string; // searching only works on toplevel children
  customer_name: string; // searching only works on toplevel children
  revenue: number;
}

export const defaultQuote: Quote = {
  customer: defaultCustomer,
  quoteLines: [],
  createdBy: '',
  createDate: '',
  expirationDate: '',
  customer_number: '',
  customer_name: '',
  revenue: 0,
};
